import { useSearchParams } from "react-router";
import { useCallback } from "react";

export function useBrandId() {
  const [searchParams, setSearchParams] = useSearchParams();

  const brandIdParam = searchParams.get("brandId");
  const brandId = brandIdParam ? Number(brandIdParam) : null;

  const setBrandId = useCallback(
    (newBrandId: number | null) => {
      const params = new URLSearchParams(searchParams);

      if (newBrandId) {
        params.set("brandId", newBrandId.toString());
      } else {
        params.delete("brandId");
      }

      setSearchParams(params);
    },
    [searchParams, setSearchParams]
  );

  return { brandId, setBrandId };
}
